import {
    AccountSignInSignUpSearchParams,
    inStoreSignUpConfigName,
    QUERY_PARAM_KEY_STORE_ID,
    QUERY_PARAM_KEY_TRANSACTION_ID
} from '~constants/Constants';
import { BaseViewController, IBaseViewController } from '~exported/BaseViewController';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { TranslationRepository } from '~repositories/TranslationRepository';
import { IN_STORE_SIGN_UP_ROUTE } from '~routes/routes';
import { ConfigurationLoadedUseCase } from '~use-cases/ConfigurationLoadedUseCase';
import { SocialPageLoadedUseCase } from '~use-cases/social/SocialPageLoadedUseCase';
import { TaggingEventSourceType } from '~utils/Analytics';
import { validateStoreId } from '~utils/DropDownUtils';
import { getSocialPageLoadType } from '~utils/SocialUtils';

export class RampViewController extends BaseViewController {
    private configRepository: ConfigRepository;
    private translationRepository: TranslationRepository;

    constructor({
        routerStore,
        userRepository,
        translationRepository,
        configRepository
    }: IBaseViewController & {
        configRepository: ConfigRepository;
        translationRepository: TranslationRepository;
    }) {
        super({ routerStore, userRepository });
        this.configRepository = configRepository;
        this.translationRepository = translationRepository;
    }

    public loaded = async () => {
        super.init();
        const socialPageLoadType = getSocialPageLoadType();
        const {
            setSignUpEventSource,
            setSignInEventSource,
            loadSession,
            resetSession
        } = this.userRepository;
        const { rampCommon: { siteType } = {} } = this.configRepository;

        this.extractReceiptData();

        // Social login flow
        if (socialPageLoadType) {
            this.setIsLoading(true);
            await loadSession();
            try {
                await new SocialPageLoadedUseCase(socialPageLoadType).execute();
            } catch (error) {
                this.setError(error);
            }
            this.setIsLoading(false);

            return;
        }

        if (siteType === 'ecommerce') {
            await resetSession();
        }
        setSignUpEventSource(TaggingEventSourceType.IN_STORE);
        setSignInEventSource(TaggingEventSourceType.IN_STORE);
        new ConfigurationLoadedUseCase(inStoreSignUpConfigName).execute();
        this.routerStore.changeCurrentRoute(IN_STORE_SIGN_UP_ROUTE);
    };

    public getRedirectUrl = (urlParams: URLSearchParams): string => {
        return urlParams.get(AccountSignInSignUpSearchParams.REDIRECT_URL) || '';
    };

    private extractReceiptData = () => {
        const { userFormStore } = this.userRepository;
        const urlParams = new URLSearchParams(window.location.search);
        const storeId = urlParams.get(QUERY_PARAM_KEY_STORE_ID);
        const transactionId = urlParams.get(QUERY_PARAM_KEY_TRANSACTION_ID);

        validateStoreId(storeId, this.translationRepository) &&
            userFormStore.setFieldValue('storeLocation', storeId as string);

        transactionId && userFormStore.setFieldValue('loyaltySignupPosTransId', transactionId);
    };
}
